import React, { useState } from 'react';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import {
  CircularProgress,
  Snackbar,
} from "@mui/material"


import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Copyright from '../../components/Copyright';
import useStyles from '../../useStyles';
import api from '../../services/api';
import background from "../../images/background.png";
import Paper from '@mui/material/Paper';
import AlterVisionLogo from '../../images/logo_alter_azul.png';

import { useAppDispatch } from './../../hooks';
import { setStores } from '../../slices/sessionSlice';
import Alert from '@mui/material/Alert';

var Cookies = require("js-cookie")

export default function SignIn() {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false)
  const [resetFailed, setResetFailed] = useState(false)
  const [loginSuccessfull, setLoginSuccessfull] = useState(undefined)
  const [errorMessage, setErrorMessage] = useState('')

  async function authUser(e) {
    e.preventDefault();

    var authBody = {
      "username": username,
      "password": password
    }

    setLoading(true)

    try {
      var res = await api.post('authUser', authBody);
      var accessGranted = res.data.accessGranted;
    } catch (err) {
      // alert("Falha ao conectar com o servidor.");
      // window.location.reload();
      if (err.response?.status === 401) {
        setErrorMessage('Usuário foi excluído pelo administrador.')
      } else {
        setErrorMessage('Falha ao conectar com o servidor.')
      }
      setLoading(false)
      setLoginSuccessfull(false)
      return
    }

    if (accessGranted) {
      sessionStorage.setItem('username', username);

      // Set token in Cookies
      Cookies.set("token", res.data.token);

      // Set permissions
      Cookies.set("permissions", res.data.permissions)

      // Get stores from DB
      const httpresponse = await api.get('getStoresByUser', {
        headers: {
          'Authorization': `Bearer ${res.data.token}`
        }
      });

      const httpStores = httpresponse.data.map((object) => ({
        "id": object.id,
        "alias_id": object.alias_id,
        "store_name": object.name,
        "store_address": object.address,
        "store_lat": object.latitude,
        "store_long": object.longitude,
        "store_services": object.services
      }));
      sessionStorage.setItem('stores', JSON.stringify(httpStores));
      dispatch(setStores(httpStores));

      if (httpStores.length < 1) {
        // User has no store registered
        setErrorMessage('Usuário não tem nenhuma loja cadastrada, peça autenticação para o seu administrador.')
        setLoading(false)
        setLoginSuccessfull(false)
        return
      }

      // Check available services
      const available_services = httpStores.reduce((services, store) => {
        store.store_services.forEach(service => {
          if (!services.includes(service)) {
            services.push(service)
          }
        });
        return services;
      }, []);
      if (available_services.includes(7) && !available_services.includes(1)) {
        window.location.href = "/vezo/storeinfo";
      }
    }
    else {
      setErrorMessage('Usuário ou senha inválida.')
      setLoginSuccessfull(false)
    }
    setLoading(false)
  }

  const handleSnackbarTimeout = () => {
    setLoginSuccessfull(undefined)
  }

  return (
    <div style={{ backgroundImage: `url(${background})`, backgroundSize: 'cover', height: '100vh' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '50px' }}>
        <Container component="main" maxWidth="xs">
          <Paper className={classes.loginPaper}>
            <CssBaseline />
            <div className={classes.paper} style={{ alignItems: 'center' }}>
              <Snackbar open={resetSuccess} autoHideDuration={6000} onClose={() => setResetSuccess(false)}>
                <Alert onClose={() => setResetSuccess(false)} severity="success">
                  Email enviado com sucesso!
                </Alert>
              </Snackbar>
              <Snackbar open={resetFailed} autoHideDuration={6000} onClose={() => setResetFailed(false)}>
                <Alert onClose={() => setResetFailed(false)} severity="warning">
                  Não foi possível encontrar uma conta associada a este email. Entre em contato com a AlterVision
                </Alert>
              </Snackbar>
              <img src={AlterVisionLogo} alt="Logo AlterVision" width="90%" style={{ marginBottom: '6vh' }} />
              <>
                <Snackbar
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                  open={loginSuccessfull === false}
                  onClose={handleSnackbarTimeout}
                  message={errorMessage}
                  autoHideDuration={3000}
                  ContentProps={{
                    style: {
                      backgroundColor: "#c98d8d",
                      color: "#a61111"
                    }
                  }}
                />
                <Typography component="h1" variant="h5">
                  Faça seu login
                </Typography>
                <form onSubmit={authUser} className={classes.form} noValidate>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="username"
                    label="Usuário"
                    name="username"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    autoFocus
                  />
                  <TextField
                    variant="outlined"
                    value={password}
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Senha"
                    onChange={e => setPassword(e.target.value)}
                    type="password"
                    id="password"
                    autoComplete="current-password"
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    id="submit"
                    color="primary"
                    onSubmit={authUser}
                    className={classes.submit}
                  >
                    {
                      loading ?
                        <CircularProgress
                          size={30}
                          style={{
                            color: "#fff"
                          }} />
                        :
                        <Typography>
                          Entrar
                        </Typography>
                    }
                  </Button>
                </form>
              </>
            </div>
            <Box mt={4}>
              <Copyright />
            </Box>
          </Paper>
        </Container>
      </div>
    </div>
  );
}
